import { render, staticRenderFns } from "./Newpassword.vue?vue&type=template&id=789d4f1f&scoped=true"
import script from "./Newpassword.vue?vue&type=script&lang=js"
export * from "./Newpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d4f1f",
  null
  
)

export default component.exports